import React from 'react';
import BulkUploadList from './BulkUploadList'
import { request } from '../helpers/request'
import { t } from '../helpers/translate.js'
let config = require('config');

class UploadDetails extends BulkUploadList {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      org: sessionStorage.getItem('org'),
      count: 1
    }
  }

  componentWillMount() {
    let listId;

    if (this.props.location.state) {
      sessionStorage.setItem('listId', JSON.stringify(this.props.location.state.listId))
      listId = this.props.location.state;
    } else {
      listId = JSON.parse(sessionStorage.getItem('listId'))
    }

    if (listId) {
      this.loadData(this.props.location.query);
    }
  }

  componentWillReceiveProps(newProps) {
    this.loadData(newProps.location.query);
    if (this.props.location.search !== newProps.location.search) {
      this.state.count++;
    }
  }

  getId() {
    return !this.props.location.state ? JSON.parse(sessionStorage.getItem('listId')) : this.props.location.state.listId;
  }

  loadData(query) {
    this.setListCriteria(query)
    this.setState({ loading: true });
    request(`${config.default.api}/uploaddetails/${this.getId()}`, 'POST', this.getRequestBody(), this.loadUploadData.bind(this));
  }

  getPageTitle() {
    return t('View Details')
  }

}

export default UploadDetails;



// WEBPACK FOOTER //
// ./src/components/UploadDetails.js